import { API } from "./axios";

export const messagingApi = {
  // Send message
  sendMessage: (castingId, recipientId, messageText, files) => {
    const formData = new FormData();
    formData.append("castingId", castingId);
    formData.append("recipientId", recipientId);
    formData.append("messageText", messageText);

    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append("attachments", file);
      });
    }

    return API.post("/messages/send", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },


  // Get messages for a conversation
  getConversation: (castingId, recipientId) =>
    API.get(`/messages/conversation/${castingId}/${recipientId}`),

  // Get all conversations for user
  getUserConversations: (userId) =>
    API.get(`/messages/conversations/${userId}`),

  // Get notifications
  getNotifications: (userId) =>
    API.get(`/notifications/user/${userId}`),

  // Mark notification as read
  markNotificationAsRead: (notificationId) =>
    API.patch(`/notifications/read/${notificationId}`),

  // Mark all notifications as read
  markAllNotificationsAsRead: (userId) =>
    API.patch(`/notifications/read-all/${userId}`),

  // Get unread notification count
  getUnreadCount: (userId) =>
    API.get(`/notifications/unread-count/${userId}`),

  // Delete a notification
  deleteNotification: (notificationId) =>
    API.delete(`/notifications/${notificationId}`),

  // Clear all notifications
  clearAllNotifications: (userId) =>
    API.delete(`/notifications/clear/${userId}`),
};
